<rappider-title-toolbar *ngIf="title"
                        [mainTitle]="title?.mainTitle"
                        [options]="title?.options"></rappider-title-toolbar>

<section>
  <div class="search-filter">
    <rappider-input-group [(ngModel)]="searchText"
                          [textbox]="inputGroupConfig?.textbox"
                          [suffixIcon]="inputGroupConfig?.suffixIcon">
    </rappider-input-group>
    <ng-container>
      <rappider-select [options]="selectConfig?.options"
                       [settings]="selectConfig?.settings"
                       [placeholder]="selectConfig?.placeholder"
                       (valueChange)="onSelectedTagsChange($event)"></rappider-select>
    </ng-container>
  </div>
</section>

<section class="card-one-list-section">
  <rappider-card-one-list [items]="getDataWithPagination()"
                          [itemCountPerRow]="itemCountPerRow"
                          [showTitleOnImage]="showTitleOnImage"
                          [showDescriptionOnImage]="showDescriptionOnImage"
                          [showPopover]="showPopover"
                          [showPopoverImage]="showPopoverImage"
                          (cardClick)="onCardClick($event)"></rappider-card-one-list>
</section>
<div class="footer-wrapper">
  <div *ngIf="isLoading"
       class="loading-wrapper">
    <span nz-icon
          nzType="loading"
          nzTheme="outline"></span>
    <span> {{loadingMessage | translate}}</span>
  </div>
  <div class="pagination-wrapper">
    <rappider-pagination [pageIndex]="paginationConfig?.pageIndex"
                         [total]="isDynamicPagination ? paginationConfig?.total : getDisplayedData()?.length"
                         [pageSize]="paginationConfig?.pageSize"
                         [showTotal]="rangeTemplate"
                         (pageIndexChange)="onPageIndexChange($event)"></rappider-pagination>
    <ng-template #rangeTemplate
                 let-range="range"
                 let-total>
      {{ range[0] }}-{{ range[1] }} of {{ isDynamicPagination ? paginationConfig?.total : getDisplayedData()?.length }}
      items
    </ng-template>
  </div>
</div>
